module.exports = __webpack_public_path__ + "img/ryzs6.e85a134d.jpg";